{
  "stream": "Stream",
  "codecLabel": "Codec",
  "codecUnknown": "codec not determined",
  "codecH265Warning": "H.265 — not every browser decodes it",
  "mainStream": "main stream",
  "noSubstream": "not set — a 2×2 grid will use the main stream",
  "resolution": "Resolution",
  "resolutionUnknown": "not determined",
  "probe": "Probe",
  "notProbed": "never run",
  "probeStream": "Probe the stream",
  "noRtspCredential": "No RTSP password attached — the camera has to let us in without one.",
  "cameraDisabled": "The camera is disabled in its settings",
  "toWall": "To the wall",
  "createCamera": "Create the camera",
  "noCameraForbidden": "This node has no camera. Creating one is for those trusted with changing nodes.",
  "newCameraHint": "This node has no camera yet. Give the stream path — the address comes from the node and the password from the credentials. A full link works too: the path is taken out of it.",
  "notSet": "not set",
  "transportLabel": "Transport",
  "enabled": "Enabled",
  "disabledHint": "A disabled camera is not shown on the wall",
  "noCameras": "No cameras yet. Add a node of type “camera” on the network map and give it an RTSP path in the camera properties.",
  "mediaServerRejected": "The media server rejected the connection ({{status}}).",
  "startTimeout": "The stream did not start within the allotted time. Check whether the camera answers (the “Probe the stream” button in the node properties) and whether the network throttles video traffic.",
  "openFailed": "The stream could not be opened.",
  "vendor": {
    "generic": "Generic camera",
    "hikvision": "Hikvision",
    "dahua": "Dahua",
    "axis": "Axis",
    "onvif": "ONVIF"
  },
  "transport": {
    "tcp": "TCP — works through a site agent too",
    "udp": "UDP — only on the same network as the platform"
  },
  "stage": {
    "opening": "opening the stream",
    "webrtc": "WebRTC",
    "fallback": "fallback channel"
  },
  "codec": {
    "mainH265": "The main stream is H.265 — the browser does not decode it, the substream is shown.",
    "h265Advice": "The browser does not decode H.265. Enable the camera's second stream (substream) in H.264 and give its path in the camera settings — the layout will pick it up on its own. The other way out is server-side transcoding, but it loads the server for every camera. In Safari 17 this stream opens unchanged; on Windows it opens in Edge and in Chrome if the HEVC Video Extensions add-on is installed from the Microsoft Store.",
    "undecodable": "The browser does not decode this stream."
  },
  "player": {
    "webrtcFailed": "The WebRTC connection was not established.",
    "noFallback": "The browser does not support the fallback transport.",
    "audioOnly": "The media server sent only an audio track: the browser does not decode the video of this stream. That is almost always H.265 — on Windows it plays once the HEVC Video Extensions add-on is installed from the Microsoft Store, and in Safari 17+ it plays right away.",
    "undecodable": "The browser does not decode this stream.",
    "fallbackUnavailable": "The fallback channel is unavailable.",
    "fallbackClosed": "The fallback channel was closed by the server."
  },
  "cell": {
    "snapshot": "Capture a frame",
    "zoomIn": "Zoom into an area",
    "zoomReset": "Reset the zoom",
    "panLeft": "Pan left",
    "panRight": "Pan right",
    "clear": "Remove the camera from the cell",
    "selected": "cell selected",
    "empty": "empty cell",
    "selectedHint": "Click a camera in the list on the left — it will land here",
    "emptyHint": "Drag a camera here from the list on the left, or click the cell to select it",
    "mseFallback": "mse · fallback transport",
    "streamSwapped": "stream substituted",
    "snapshotSaved": "snapshot saved",
    "channelN": "Channel {{channel}}",
    "pickChannel": "Pick a channel"
  },
  "recorder": {
    "title": "Video recorder",
    "newHint": "This node has no recorder yet. Choose how to talk to it: the address comes from the node and the password from the RTSP credentials. The platform detects the channels on its own right after creation.",
    "forbidden": "This node has no recorder. Creating one is for those trusted with changing nodes.",
    "protocolLabel": "Protocol",
    "protocol": {
      "dahua": "Dahua — HTTP API",
      "hikvision": "Hikvision — ISAPI",
      "rtsp": "RTSP only — channels by trial"
    },
    "httpPort": "Web interface port",
    "httpPortHint": "the recorder API lives on it",
    "rtspPort": "RTSP port",
    "mainTemplate": "Main stream",
    "subTemplate": "Substream",
    "templateHint": "{channel} is replaced with the channel number. The platform finds the channels by trial: it tries 1, 2, 3… and stops after a run of silent ones.",
    "preset": "Fill in:",
    "maxChannels": "Channels up to",
    "create": "Create the recorder",
    "detect": "Detect channels",
    "detecting": "Detecting channels…",
    "detected": "Channels found: {{found}}. New: {{added}}, removed: {{removed}}.",
    "channels": "Channels",
    "channelsDetected_one": "{{count}} channel detected",
    "channelsDetected_other": "{{count}} channels detected",
    "withoutVideo": "{{silent}} without video",
    "noChannels": "not detected yet",
    "channelUnavailable": "no video",
    "lastDetect": "Detection",
    "neverDetected": "never run",
    "noCredential": "No RTSP password attached — the recorder has to let us in without one.",
    "enabledHint": "A disabled recorder does not put its channels on the wall",
    "archiveHint": "The platform sets the channel number and track for each channel on its own."
  },
  "sound": {
    "on": "Turn the sound on",
    "off": "Turn the sound off",
    "volume": "Volume",
    "volumeAt": "Volume {{percent}}%",
    "mutedShort": "off",
    "unavailable": "no sound",
    "unavailableHint": "The camera sends no audio: the microphone is off in its settings, or there is none"
  },
  "overlay": {
    "h265": "H.265 without transcoding",
    "codecUnsupported": "The browser does not decode the stream",
    "streamFailed": "The stream did not start",
    "cameraSilent": "The camera is not answering. Check its power and the link to the site, then try again.",
    "retry": "Try connecting again"
  },
  "hint": {
    "site": "Site: {{name}}",
    "address": "Address: {{address}}",
    "noAddress": "not set",
    "notes": "Description: {{notes}}",
    "disabled": "The camera is disabled in its settings — there will be no stream"
  },
  "rtsp": {
    "hostAlready": "the address {{host}} is already set on the node",
    "hostMove": "move the address {{host}} into the node's own Address field",
    "portBelow": "give the port {{port}} below",
    "user": "create the user name as an RTSP credential and attach it to the node — below",
    "userAndPassword": "create the user name and password as an RTSP credential and attach it to the node — below",
    "pathOnly": "Only the path was taken from the link: {{parts}}."
  },
  "wall": {
    "cameras": "Cameras",
    "loadingCameras": "Loading the cameras…",
    "streamLimit": "The platform does not open more than {{limit}} streams at once. Clear a camera from another cell.",
    "layoutName": "Layout name",
    "layoutExample": "Day shift",
    "layoutSaved": "Layout “{{name}}” saved.",
    "layoutDeleted": "The layout was deleted. The cameras stayed on the wall.",
    "soundBlocked": "The browser did not let the sound start on its own — it only allows that after a human action. Click the speaker in the corner of a cell.",
    "customGrid": "Custom layout",
    "gridTitle": "Layout {{grid}}",
    "custom": "custom",
    "layout": "Layout",
    "noLayout": "none selected",
    "shared": "shared",
    "state": "Wall state",
    "streamsOf": "Streams: {{open}} of {{limit}}.",
    "streamsShort": "{{open}} streams / {{limit}}",
    "quality": "Quality: {{note}}.",
    "transport": "Transport: {{list}}.",
    "deleteLayout": "Delete the layout",
    "saveLayout": "Save the layout",
    "camerasCount": "Cameras · {{count}}",
    "channelsShort": "channels: {{count}}",
    "pickHintLabel": "How to fill the cells",
    "pickHint": "Click a cell, then a camera — it goes into the selected cell. Or drag a camera onto a cell. Double-click a cell for full screen, main stream and sound."
  },
  "onWall": "on the wall",
  "title": "Video",
  "warning": {
    "noSubstream": "The camera has no substream configured — the main stream is shown. That loads the link.",
    "substreamSilent": "The substream did not answer at the last probe — the main stream is shown."
  }
}
